import React, { useEffect, useState, useRef } from "react";
import $ from "jquery";
import axios from "axios";
import { Link, useOutletContext } from "react-router-dom";
import { useForm } from "react-hook-form";
import { MaterialReactTable } from "material-react-table";
import { useNavigate } from "react-router-dom";
import { currency_converter_inr } from "../../utils/currencyUtils";
import CountUp from "react-countup";
function Closure() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const PINE_BASE_URL = process.env.REACT_APP_PINE_BASE_URL;
  const { setGlobalLoading, token } = useOutletContext();
  const navigate = useNavigate();

  const [options, setoptions] = useState([]);
  const [optionsLoaded, setOptionsLoaded] = useState(false);

  const columns = [
        {
        accessorKey: "name",
        header: "Candidate Name",
        size: 200,
        muiTableHeadCellProps: {
            sx: {
            position: "sticky",
            left: 0,
            zIndex: 3,
            backgroundColor: "white",
            boxShadow: "2px 0 5px -2px rgba(0,0,0,0.3)", // border/shadow effect
            },
        },
        muiTableBodyCellProps: {
            sx: {
            position: "sticky",
            left: 0,
            zIndex: 1,
            backgroundColor: "white",
            boxShadow: "2px 0 5px -2px rgba(0,0,0,0.3)", // border/shadow effect
            },
        },
        Cell: ({ row }) => {
            return (
            <div className="d-flex align-items-center file-name-icon">
                <div className="ms-2">
                <h6 className="fw-medium mb-0">
                    <Link
                      to={`/candidates/view/${row.original.candidate_id}`}
                    >
                    {row.original.name}
                    </Link>
                </h6>
                </div>
            </div>
            );
        },
        },
        {
        accessorKey: "location",
        header: "Location",
        size: 100,
        },
        {
        accessorKey: "client_name",
        header: "Company",
        },
        {
        accessorKey: "last_company",
        header: "Previous Company",
        size: 100,
        },
        {
        accessorKey: "role",
        header: "Role",
        },
        {
        accessorKey: "doj",
        header: "DOJ",
        },
        {
        accessorKey: "resource",
        header: "Resource",
        size: 100,
        },
        {
        accessorKey: "assigned_to",
        header: "Assigned To",
        size: 100,
        },
        {
        accessorKey: "client_maneger",
        header: "Role Manager",
        size: 100,
        },
        {
        accessorKey: "industryMaster",
        header: "Major Industry",
        size: 100,
        },
        {
        accessorKey: "industry",
        header: "Minor Industry",
        size: 100,
        },
        {
        accessorKey: "majorFunction",
        header: "Major Function",
        size: 100,
        },
        {
        accessorKey: "minorFunction",
        header: "Minor Function",
        size: 100,
        },
        {
        accessorKey: "country",
        header: "Country",
        size: 100,
        },
        {
        accessorKey: "region",
        header: "Region",
        size: 100,
        },
        {
        accessorKey: "roleLevel",
        header: "Role Level",
        size: 100,
        },
    ];

  async function fetchOptions() {
    setGlobalLoading(true); //  Show loader before API call
    try {
      const response = await axios.get(
        `${API_BASE_URL}/reports/get_closure_list/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setoptions(response.data.closure_list || []);
    } catch (error) {
      console.error("API Error:", error);
      setoptions([]); // Prevent errors from breaking UI
      setGlobalLoading(false);
    }finally{
      setGlobalLoading(false);
    }
  }

  useEffect(() => {
    fetchOptions();
  }, []);
return (
<>
    <div className="content">
        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
          <div className="my-auto mb-2">
            <h2 className="mb-1">Closure Report</h2>
          </div>
        </div>
        <div className="card">
          <div className="card-body p-0">
            <div className="custom-datatable-filter table-responsive">
              <MaterialReactTable
                columns={columns}
                data={options}
                initialState={{
                  pagination: { pageSize: 200 },
                }}
                muiTableBodyRowProps={{
                  sx: {
                    height: "20px", // compact row height
                  },
                }}
                muiTableBodyCellProps={{
                  sx: {
                    padding: "2px 4px", // compact cell padding
                  },
                }}
                muiTableHeadCellProps={{
                  sx: {
                    padding: "2px 4px", // same as body cells
                    height: "30px", // or less
                  },
                }}
              />
            </div>
          </div>
        </div>
      </div>
</>
);

}
export default Closure;
